/* eslint-disable react/prop-types */
import { forwardRef, ReactElement } from 'react'
import Slider, { CustomArrowProps } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { CarouselWrapper, StyledCarousel } from './styles'
import { CarouselProps } from './props'
import { Button, SVG } from '../../Atoms'
import { SVGs } from '../..'

const NextArrow = ({
    currentSlide,
    slideCount,
    ...props
}: CustomArrowProps) => (
    <Button {...props} data-cy="NextSlide">
        <SVG src={SVGs.ChevronRight} />
    </Button>
)

const PrevArrow = ({
    currentSlide,
    slideCount,
    ...props
}: CustomArrowProps) => (
    <Button {...props} data-cy="PrevSlide">
        <SVG src={SVGs.ChevronLeft} />
    </Button>
)

const Carousel = forwardRef<Slider, CarouselProps>(
    (
        {
            infinite = false,
            nextArrow = <NextArrow />,
            prevArrow = <PrevArrow />,
            ...props
        },
        ref
    ): ReactElement => (
        <CarouselWrapper>
            <StyledCarousel
                {...props}
                infinite={infinite}
                nextArrow={nextArrow}
                prevArrow={prevArrow}
                ref={ref}
            />
        </CarouselWrapper>
    )
)

Carousel.displayName = 'Carousel'

export default Carousel

export { StyledCarousel }
